import { RouteObject } from "react-router"
import { lazy, Suspense } from "react"
import { LoadingFallback } from "@/components/app/LoadingFallback.tsx"
import { Patient } from "@/pages/Patient/Patient.tsx"

// Lazy load all components with named exports

const NurseTodo = lazy(() => import("@/pages/Patient/NurseTodo.tsx").then(module => ({ default: module.NurseTodo })))
const InputOutput = lazy(() => import("@/pages/Patient/InputOutput.tsx").then(module => ({ default: module.InputOutput })))
const ProcedureReport = lazy(() => import("@/pages/Patient/ProcedureReport.tsx").then(module => ({ default: module.ProcedureReport })))
const TaskAssigner = lazy(() => import("@/pages/Patient/TaskAssigner.tsx").then(module => ({ default: module.TaskAssigner })))
const Vitals = lazy(() => import("@/pages/Patient/Vitals.tsx").then(module => ({ default: module.Vitals })))
const Alerts = lazy(() => import("@/pages/Patient/Alerts.tsx").then(module => ({ default: module.Alerts })))
const InvestigationResults = lazy(() => import("@/pages/Patient/InvestigationResults.tsx").then(module => ({ default: module.InvestigationResults })))
const HimsDischargeSummary = lazy(() => import("@/pages/Patient/HimsDischargeSummary.tsx").then(module => ({ default: module.HimsDischargeSummary })))
const TasksList = lazy(() => import("@/pages/Patient/TasksList.tsx").then(module => ({ default: module.TasksList })))
const DischargeSummary = lazy(() => import("@/pages/Patient/DischargeSummary.tsx").then(module => ({ default: module.DischargeSummary })))
const EMar = lazy(() => import("@/pages/Patient/EMar.tsx").then(module => ({ default: module.EMar })))
const Doctor = lazy(() => import("@/pages/Patient/Doctor.tsx").then(module => ({ default: module.Doctor })))
const Dietician = lazy(() => import("@/pages/Patient/Dietician.tsx").then(module => ({ default: module.Dietician })))
const RehabilitationNotes = lazy(() => import("@/pages/Patient/RehabilitationNotes.tsx").then(module => ({ default: module.RehabilitationNotes })))
const ConsentForms = lazy(() => import("@/pages/Patient/ConsentForms.tsx").then(module => ({ default: module.ConsentForms })))
const Nursing = lazy(() => import("@/pages/Patient/Nursing.tsx").then(module => ({ default: module.Nursing })))
const HICBundles = lazy(() => import("@/pages/Patient/HICBundles.tsx").then(module => ({ default: module.HICBundles })))
const AssessmentScores = lazy(() => import("@/pages/Patient/AssessmentScores.tsx").then(module => ({ default: module.AssessmentScores })))
const CaseSheet = lazy(() => import("@/pages/Patient/CaseSheet.tsx").then(module => ({ default: module.CaseSheet })))
const OperationTheatre = lazy(() => import("@/pages/Patient/OperationTheatre.tsx").then(module => ({ default: module.OperationTheatre })))
const GCS = lazy(() => import("@/pages/Patient/GCS.tsx").then(module => ({ default: module.GCS })))
const GRBS = lazy(() => import("@/pages/Patient/GRBS.tsx").then(module => ({ default: module.GRBS })))
const Dialysis = lazy(() => import("@/pages/Patient/Dialysis.tsx").then(module => ({ default: module.Dialysis })))
const LongitudinalHistory = lazy(() => import("@/pages/Patient/LongitudinalHistory.tsx").then(module => ({ default: module.LongitudinalHistory })))
const ActivityChart = lazy(() => import("@/pages/Patient/ActivityChart.tsx").then(module => ({ default: module.ActivityChart })))
const ClinicalScores = lazy(() => import("@/pages/Patient/ClinicalScores.tsx").then(module => ({ default: module.ClinicalScores })))


export const patient: RouteObject = {
  path: "patient/:id",
  element: <Patient />,
  children: [
    {
      path: "nurseTodo",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <NurseTodo />
        </Suspense>
      ),
    },
    {
      path: "inputOutput",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <InputOutput />
        </Suspense>
      ),
    },
    {
      path: "procedureReport",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <ProcedureReport />
        </Suspense>
      ),
    },
    {
      path: "taskAssigner",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <TaskAssigner />
        </Suspense>
      ),
    },
    {
      path: "vitals",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <Vitals />
        </Suspense>
      ),
    },
    {
      path: "alerts",
      element:(
        <Suspense fallback={<LoadingFallback/>}>
          <Alerts/>
        </Suspense>
      )
    },
    {
      path: "investigationResults",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <InvestigationResults />
        </Suspense>
      ),
    },
    {
      path: "himsDischargeSummary",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <HimsDischargeSummary />
        </Suspense>
      ),
    },
    {
      path: "tasksList",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <TasksList />
        </Suspense>
      ),
    },
    {
      path: "dischargeSummary",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <DischargeSummary />
        </Suspense>
      ),
    },
    {
      path: "eMar",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <EMar />
        </Suspense>
      ),
    },
    {
      path: "doctor",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <Doctor />
        </Suspense>
      ),
    },
    {
      path: "dietician",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <Dietician />
        </Suspense>
      ),
    },
    {
      path: "rehabilitationNotes",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <RehabilitationNotes />
        </Suspense>
      ),
    },
    {
      path: "consentForms",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <ConsentForms />
        </Suspense>
      ),
    },
    {
      path: "nursing",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <Nursing />
        </Suspense>
      ),
    },
    {
      path: "hicBundles",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <HICBundles />
        </Suspense>
      ),
    },
    {
      path: "assessmentScores",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <AssessmentScores />
        </Suspense>
      ),
    },
    {
      path: "caseSheet",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <CaseSheet />
        </Suspense>
      ),
    },
    {
      path: "operationTheatre",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <OperationTheatre />
        </Suspense>
      ),
    },
    {
      path: "gcs",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <GCS />
        </Suspense>
      ),
    },
    {
      path: "grbs",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <GRBS />
        </Suspense>
      ),
    },
    {
      path: "dialysis",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <Dialysis />
        </Suspense>
      ),
    },
    {
      path: "longitudinalHistory",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <LongitudinalHistory />
        </Suspense>
      ),
    },
    {
      path: "activityChart",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <ActivityChart />
        </Suspense>
      ),
    },
    {
      path: "clinicalScores",
      element: (
        <Suspense fallback={<LoadingFallback />}>
          <ClinicalScores />
        </Suspense>
      ),
    },
  ],
}
